import { template } from "@ember/template-compiler";
import type { TOC } from '@ember/component/template-only';
export const Div: TOC<{
    Element: HTMLDivElement;
    Blocks: {
        default: [];
    };
}> = template(`
  <div ...attributes>{{yield}}</div>
`, {
    eval () {
        return eval(arguments[0]);
    }
});
export const Label: TOC<{
    Element: HTMLLabelElement;
    Args: {
        for: string;
    };
    Blocks: {
        default: [];
    };
}> = template(`
  <label for={{@for}} ...attributes>{{yield}}</label>
`, {
    eval () {
        return eval(arguments[0]);
    }
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL2VtYmVyLXByaW1pdGl2ZXMvZW1iZXItcHJpbWl0aXZlcy9lbWJlci1wcmltaXRpdmVzL3NyYy9jb21wb25lbnRzLy1wcml2YXRlL3R5cGVkLWVsZW1lbnRzLmd0cyJdLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgdHlwZSB7IFRPQyB9IGZyb20gJ0BlbWJlci9jb21wb25lbnQvdGVtcGxhdGUtb25seSc7XG5cbmV4cG9ydCBjb25zdCBEaXY6IFRPQzx7IEVsZW1lbnQ6IEhUTUxEaXZFbGVtZW50OyBCbG9ja3M6IHsgZGVmYXVsdDogW10gfSB9PiA9IDx0ZW1wbGF0ZT5cbiAgPGRpdiAuLi5hdHRyaWJ1dGVzPnt7eWllbGR9fTwvZGl2PlxuPC90ZW1wbGF0ZT47XG5cbmV4cG9ydCBjb25zdCBMYWJlbDogVE9DPHtcbiAgRWxlbWVudDogSFRNTExhYmVsRWxlbWVudDtcbiAgQXJnczogeyBmb3I6IHN0cmluZyB9O1xuICBCbG9ja3M6IHsgZGVmYXVsdDogW10gfTtcbn0-ID0gPHRlbXBsYXRlPlxuICA8bGFiZWwgZm9yPXt7QGZvcn19IC4uLmF0dHJpYnV0ZXM-e3t5aWVsZH19PC9sYWJlbD5cbjwvdGVtcGxhdGU-O1xuIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFBQSxjQUFjLEdBQUcsUUFBUSxpQ0FBaUM7QUFFMUQsT0FBTyxNQUFNLEtBQUs7SUFBTSxTQUFTO0lBQWdCO1FBQVU7O0tBQW1CLFNBQVUsQ0FBQTs7QUFFeEYsQ0FBQSxFQUFBO0lBQUE7UUFBQSxPQUFBLEtBQUEsU0FBQSxDQUFBLEVBQVc7SUFBRDtBQUFBLEdBQUU7QUFFWixPQUFPLE1BQU0sT0FBTztJQUNsQixTQUFTO0lBQ1Q7UUFBUSxLQUFLLE1BQU07O0lBQ25CO1FBQVU7O0tBQ1AsU0FBVSxDQUFBOztBQUVmLENBQUEsRUFBQTtJQUFBO1FBQUEsT0FBQSxLQUFBLFNBQUEsQ0FBQSxFQUFXO0lBQUQ7QUFBQSxHQUFFIn0